import { useCallback, useEffect, useState } from 'react';
import employeeInterestService from '../services/employeeinterest.service';

export function useJobApplications() {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await employeeInterestService.fetchApplications();
            setApplications(data);
        } catch (err) {
            console.error('Error fetching job applications', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { applications, loading, error, refresh: fetchData };
}
